import i18n from '../i18n'
import {
  LOCALE_STORAGE_KEY,
  normalizeLocale,
  type SupportedLocale,
} from '../i18n/constants'
import { authService } from '../services/authService'
import { getAuthToken } from '../utils/authStorage'
import {
  getLucasTtsVoice,
  setLucasTtsVoice,
  type LucasTtsVoice,
} from './lucasTtsPreferences'

/** Apply server preferred_locale to i18n + localStorage (login /me). */
export function applyAccountLocale(preferred?: string | null): SupportedLocale {
  const locale = normalizeLocale(preferred || i18n.language)
  try {
    window.localStorage.setItem(LOCALE_STORAGE_KEY, locale)
  } catch {
    /* ignore */
  }
  if (normalizeLocale(i18n.language) !== locale) {
    void i18n.changeLanguage(locale)
  }
  document.documentElement.lang = locale
  return locale
}

/** Persist UI locale to the server when logged in. */
export async function syncPreferredLocaleToServer(
  locale: SupportedLocale,
): Promise<void> {
  if (!getAuthToken()) return
  try {
    await authService.updateCurrentUser({ preferred_locale: locale })
  } catch {
    /* non-blocking */
  }
}

export async function syncVoicePreferenceToServer(
  voice: LucasTtsVoice,
): Promise<void> {
  setLucasTtsVoice(voice)
  if (!getAuthToken()) return
  try {
    await authService.updateCurrentUser({ voice_preference: voice })
  } catch {
    /* non-blocking */
  }
}

/** Seed local voice from server after login. */
export function applyAccountVoicePreference(voice?: string | null): LucasTtsVoice {
  if (voice === 'male' || voice === 'female') {
    setLucasTtsVoice(voice)
    return voice
  }
  return getLucasTtsVoice()
}

export function currentUiLocale(): SupportedLocale {
  return normalizeLocale(i18n.resolvedLanguage ?? i18n.language)
}
